<script>
import axios from '@/utils/axios';

export default {
  name: 'HrmAssetCategoryModal',
  inject: ['setLoading'],
  props: {
    category: { type: Object, default: null },
  },
  emits: ['saved'],
  data() {
    return {
      errors: {},
      form: {
        name: '',
        description: '',
      },
    };
  },

  computed: {
    isEdit() {
      return !!(this.category && this.category.id);
    },
  },

  watch: {
    category: {
      immediate: true,
      handler(val) {
        this.errors = {};
        this.form = val ? {
          name: val.name,
          description: val.description || '',
        } : { name: '', description: '' };
      },
    },
  },

  methods: {
    async submit() {
      this.errors = {};
      this.setLoading(true);
      try {
        if (this.isEdit) {
          await axios.put(`/hrms/assets/categories/${this.category.id}`, this.form);
          this.$swalToast('Category updated successfully.');
        } else {
          await axios.post('/hrms/assets/categories', this.form);
          this.$swalToast('Category added successfully.');
        }
        this.$closeModal('hrm_asset_category_modal');
        this.$emit('saved');
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  }
};
</script>

<template>
  <div class="modal fade" id="hrm_asset_category_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEdit ? 'Edit Category' : 'Add Category' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="mb-3">
            <label class="form-label">Category Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.name" placeholder="e.g. Laptop">
            <span class="text-danger" style="font-size:12px;" v-if="errors.name">{{ errors.name[0] }}</span>
          </div>

          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" v-model="form.description" placeholder="Optional description"></textarea>
            <span class="text-danger" style="font-size:12px;" v-if="errors.description">{{ errors.description[0] }}</span>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="!form.name" @click="submit">
            {{ isEdit ? 'Update Category' : 'Add Category' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>